import {useMe} from '@/haligator-factory';
import {useHalState} from '@synako/haligator';
import {PropsWithChildren, createContext, useCallback, useContext} from 'react';
// import {Outlet, useLocation} from 'react-router-dom';
import {TrackEvt} from 'api-types/ffconnect';

/**
 * Permet de tracker les page-views avec le react-router
 */
// export function TrackPageView() {
//   const location = useLocation();
//   const capture = useCapture();

//   // Track pageviews
//   useEffect(() => {
//     capture({
//       name: '$pageview',
//       props: {
//         $current_url: window.location.href,
//       },
//     });
//   }, [capture, location]);
//   return <Outlet />;
// }

/** Tout simple pour typer les events */
type Capture = (track: TrackEvt) => void;

const CaptureContext = createContext<{
  capture: Capture;
}>({
  capture: () => {
    /*no op */
  },
});

const CaptureProvider: React.FC<PropsWithChildren> = ({children}) => {
  const consent = useHalState(
    useMe().follow('contact').follow('consentement-analytics'),
  );
  const {state: meState} = useHalState(useMe());
  const capture = useCallback<Capture>(
    (event) => {
      if (consent.data?.consentement === 'refuse') {
        return;
      }
      meState?.submitCommand('c:track', {events: [event]});
    },
    [consent.data?.consentement, meState],
  );
  return (
    <CaptureContext.Provider value={{capture}}>
      {children}
    </CaptureContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export function useCapture() {
  const value = useContext(CaptureContext);
  return value.capture;
}

export const CaptureSetup: React.FC<PropsWithChildren> = ({children}) => {
  return <CaptureProvider>{children}</CaptureProvider>;
};
